export class ResponseNotOkError extends Error {
    response;
    constructor(response) {
        super(`The ${response.url} API returned status code '${response.status} ${response.statusText}'`);
        this.response = response;
        this.response = response;
    }
}
export class FetchApi {
    baseUrl;
    authentication;
    scopes;
    userReadToken;
    appName;
    constructor(baseUrl, authentication, scopes, userReadToken, appName) {
        this.baseUrl = baseUrl;
        this.authentication = authentication;
        this.scopes = scopes;
        this.userReadToken = userReadToken;
        this.appName = appName;
    }
    setAuthentication(authentication) {
        this.authentication = authentication;
    }
    setAppName(isOpp) {
        this.appName = isOpp;
    }
    async jsonInJsonOut(path, init) {
        return (await (await this.run(path, {
            ...init,
            headers: {
                ...init?.headers,
                "Content-Type": "application/json",
            },
        })).json());
    }
    async jsonInCSVOut(path, init, filename = "data.csv") {
        const response = await this.run(path, {
            ...init,
            headers: {
                ...init?.headers,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            throw new ResponseNotOkError(response);
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }
    async jsonInBlobOut(path, init) {
        const response = await this.run(path, {
            ...init,
            headers: {
                ...init?.headers,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            throw new ResponseNotOkError(response);
        }
        return {
            blob: await response.blob(),
            contentType: response.headers.get("content-type"),
        };
    }
    async jsonInVoidOut(path, init) {
        await this.run(path, {
            ...init,
            headers: {
                ...init?.headers,
                "Content-Type": "application/json",
            },
        });
    }
    async multipartInJsonOut(path, init) {
        return (await (await this.run(path, init)).json());
    }
    async run(path, init) {
        const accessToken = await this.authentication.getToken({
            scopes: this.scopes,
        });
        const res = await fetch(`${this.baseUrl}${path}`, {
            ...init,
            headers: {
                ...init?.headers,
                Authorization: `Bearer ${accessToken}`,
                ...(this.userReadToken != null
                    ? { UserReadToken: this.userReadToken }
                    : {}),
                ...(this.appName !== undefined ? { "x-app-name": this.appName } : {}),
            },
        });
        if (!res.ok) {
            throw new ResponseNotOkError(res);
        }
        return res;
    }
}
//# sourceMappingURL=fetchApi.js.map